import { FC, useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { ModalComponentBaseProps } from '@pcmp/react-providers';
import { useUser } from '@/redux/features/session/hooks';
import FindUserSider, { FindUserData } from '../find-user';
import { useShoppingBag } from '@/redux/features/shopping-bag/hooks';
import {
  useWebshopMode,
  WebshopModeProvider,
} from '@/components/page-widgets/webshop/context';
import { OrderType } from '@/redux/back-dashboard-api';

const OrderOnBehalfSiderContent: FC<ModalComponentBaseProps> = (props) => {
  // Hooks
  const { t } = useTranslation();
  const { setOnBehalfOf } = useWebshopMode();
  const user = useUser();
  const shoppingBag = useShoppingBag();
  // Data
  const selectedUser = useMemo(() => {
    if (shoppingBag.onBehalfOf) return shoppingBag.onBehalfOf;

    return {
      displayName: user.displayName || '',
      email: user.email,
      manager: user.manager?.mail || '',
    };
  }, [shoppingBag.onBehalfOf, user]);

  const handleConfirm = useCallback(
    (selectedUser: FindUserData) => {
      if (!user) return;

      const onBehalfOf =
        selectedUser.email === user.email
          ? null
          : {
              email: selectedUser.email,
              displayName: selectedUser.displayName,
              manager: selectedUser.manager,
            };

      setOnBehalfOf(onBehalfOf);
    },
    [user, setOnBehalfOf]
  );

  return (
    <FindUserSider
      {...props}
      descriptionText={t('page.findUser.description')}
      onConfirm={handleConfirm}
      filterByLocation="include"
      user={selectedUser}
      displayCurrentUser
    />
  );
};

const OrderOnBehalfSider: FC<ModalComponentBaseProps> = (props) => {
  return (
    <WebshopModeProvider orderType={OrderType.Order}>
      <OrderOnBehalfSiderContent {...props} />
    </WebshopModeProvider>
  );
};

export default OrderOnBehalfSider;
